/** import external dependencies */
import 'jquery';
import 'bootstrap';

/** import local dependencies */
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import archive from './routes/archive';
import single from './routes/single';
import job from './routes/job';
import contact from './routes/contact-us';



/**
 * Populate Router instance with DOM routes
 * @type {Router} routes - An instance of our router
 */
const routes = new Router({
  /** All pages */
  common,
  /** Home page */
  home,
  /** About Us page, note the change from about-us to aboutUs. */
  aboutUs,
  /** Archive page. */
  archive,
  /** Post page. */
  single,
    /** Jobs page. */
  job,
  /** Contact Page*/
  contact,
});


/** Load Events */
jQuery(document).ready(() => routes.loadEvents());





// WEBPACK FOOTER //
// ./scripts/main.js